import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Highlight } from '../Highlight';
import { bonos, bonosTotal } from '../../data/landing';
export function Bonos() {
  return <section id="bonos" className="scroll-mt-4 bg-white px-5 py-16 md:py-24" data-id="element-60" data-mp="1hig417vib375">
      <div className="mx-auto max-w-5xl" data-id="element-61" data-mp="1ckejeiifmvtk">
        <SectionHeading eyebrow="Siempre incluidos" title={<>
              5 Bonos <Highlight data-id="element-63" data-mp="ovvbw577in2j">estratégicos</Highlight>
            </>} data-id="element-62" data-mp="1clh7kiodek5s" />

        <ul className="mt-12 space-y-3" data-id="element-64" data-mp="jwa9tlwqpyll">
          {bonos.map(b => <li key={b.number} className="grid grid-cols-[auto_1fr] gap-4 rounded-2xl border border-gold/60 bg-gold-soft p-5 sm:grid-cols-[auto_1fr_auto] sm:items-center md:p-6" data-id="element-65" data-mp="jxtstk9s6nr2">
              <span className="flex h-14 w-14 flex-col items-center justify-center rounded-xl bg-gold text-brand" data-id="element-66" data-mp="tteshbrdnbxn">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-67" data-mp="62rhghm6066v" />
                <span className="text-xs font-black" data-id="element-68" data-mp="14hkq2kskxj5">{b.number}</span>
              </span>
              <div data-id="element-69" data-mp="2zb78472wyxpn">
                <p className="text-xs font-black uppercase tracking-wider text-brand/70" data-id="element-70" data-mp="2z9mfin05touf">
                  Bono {Number(b.number)}
                </p>
                <p className="text-lg font-extrabold leading-tight text-brand" data-id="element-71" data-mp="3907dq9bx8rct">{b.title}</p>
                <p className="mt-1 text-sm text-charcoal md:text-base" data-id="element-72" data-mp="3d1su44nnznrr">{b.description}</p>
              </div>
              <div className="col-span-2 flex items-center justify-between gap-4 border-t border-gold/50 pt-3 sm:col-span-1 sm:flex-col sm:items-end sm:border-t-0 sm:pt-0" data-id="element-73" data-mp="2gbta9e22d2tv">
                <span className="whitespace-nowrap text-sm text-muted" data-id="element-74" data-mp="2lcqtltyt82wy">
                  Valorado: <span className="line-through decoration-danger" data-id="element-75" data-mp="2pawuilcyvo9y">{b.value}</span>
                </span>
                <span className="rounded-full bg-brand px-3 py-1 text-sm font-black uppercase text-white" data-id="element-76" data-mp="2ucm9gc3b8m3b">
                  Gratis
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 rounded-2xl bg-brand px-6 py-5 text-center sm:flex-row sm:text-left" data-id="element-77" data-mp="9n6lrpze1dhw">
          <p className="text-lg text-white" data-id="element-78" data-mp="21nenyw2gczf0">
            Valor total bonos:{' '}
            <span className="font-black line-through decoration-gold decoration-2" data-id="element-79" data-mp="2fm5xs6aa7yxc">{bonosTotal}</span>
          </p>
          <p className="text-xl font-black uppercase text-gold" data-id="element-80" data-mp="2an1rbneqsfap">→ Gratis con tu MegaPack</p>
        </div>
      </div>
    </section>;
}